import { useUIStore } from "../../stores";
import DriverModal from "../driver/DriverModal";
import RideModal from "../ride/RideModal";
import ChooseDriver from "../ride/ChooseDriver";
import ConfirmRide from "../ride/ConfirmRide";
import Login from "../auth/Login";
import Signup from "../auth/Signup";
import ForgotPassword from "../auth/ForgotPassword";
import UploadProfilePicture from "../profile/UploadProfilePicture";
import ConfirmDeleteProfile from "../profile/ConfirmDeleteProfile";

function ModalShell({
  modalType,
  showModal,
  setModalType,
  setShowModal,
  modalObj,
  setModalObj,
  itemId,
  isAuth,
  userId,
}) {
  const { sidebarCollapsed } = useUIStore();

  // Close modal logic to stop showing modal.
  const onModalClose = () => {
    setShowModal(false);
    setModalType(null);
  };

  // Transition from choose-driver to confirm-ride
  const handleChooseDriver = (driverIds) => {
    setModalObj((prev) => ({
      ...prev,
      requestedDriverIds: driverIds.length > 0 ? driverIds : null,
    }));
    setModalType("confirm-ride");
  };

  if (!showModal) {
    return null;
  }

  const modalComponentFactory = (type) => {
    switch (type) {
      case "login":
        return <Login isDriver={false} onForgotPassword={() => setModalType("forgot-password")} />;
      case "signup":
        return <Signup />;
      case "driver-login":
        return <Login isDriver={true} onForgotPassword={() => setModalType("forgot-password-driver")} />;
      case "forgot-password":
        return <ForgotPassword isDriver={false} />;
      case "forgot-password-driver":
        return <ForgotPassword isDriver={true} />;
      case "choose-driver":
        return (
          <ChooseDriver
            userId={userId}
            isAuth={isAuth}
            onChooseDriver={handleChooseDriver}
            onBack={onModalClose}
            prefillDriverIds={modalObj?.prefillDriverIds}
            passengers={modalObj?.passengers}
          />
        );
      case "confirm-ride":
        return (
          <ConfirmRide onModalClose={onModalClose} confirmObj={modalObj} />
        );
      case "upload-picture":
        return <UploadProfilePicture onSuccess={onModalClose} />;
      case "delete-user":
        return <ConfirmDeleteProfile />;
      case "available":
        return <DriverModal id={itemId} type={type} />;
      case "favorite":
        return <DriverModal id={itemId} type={type} />;
      case "availableRides":
        return <RideModal id={itemId} type={type} />;
      case "currentRides":
        return <RideModal id={itemId} type={type} />;
      case "rideHistory":
        return <RideModal id={itemId} type={type} />;
      default:
        return "Something went wrong with the modal.";
    }
  };

  const isLargeModal =
    modalType === "confirm-ride" ||
    modalType === "choose-driver" ||
    modalType === "availableRides" ||
    modalType === "currentRides" ||
    modalType === "rideHistory";
  const modalBody = modalComponentFactory(modalType);

  // Hide the shell Close button for choose-driver and confirm-ride
  // since they have their own Back/Close buttons
  const hideShellClose =
    modalType === "choose-driver" || modalType === "confirm-ride";

  return (
    <div
      id="modal"
      className={`fixed inset-y-0 right-0 flex items-center justify-center z-20 overflow-y-auto bg-black/50 left-0 ${
        sidebarCollapsed ? "lg:left-20" : "lg:left-64"
      }`}
      onClick={onModalClose}
    >
      <div
        className={`modal-color rounded-xl border border-white/20 shadow-2xl mx-4 my-8 ${
          isLargeModal ? "w-full max-w-xl p-8" : "w-full max-w-md p-5"
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        {modalBody}

        {!hideShellClose && (
          <button
            className="btn btn-red btn-md mx-auto mt-4 block"
            onClick={onModalClose}
          >
            Close
          </button>
        )}
      </div>
    </div>
  );
}

export default ModalShell;
